import { combineReducers } from "redux";
import { templateReducer } from "./templateReducer";
import { zoneReducer } from "./zoneReducer";
import { emsReducer } from "./EmsReducer";
import { loaderReducer } from "./loaderReducer";
import { fileUploadReducer } from "./fileUploadReducer";
import { documentReducer } from "./documentReducer";
import { authReducer } from "./authReducer";

export const rootReducer = combineReducers({
  template: templateReducer,
  zone: zoneReducer,
  ems: emsReducer,
  loader: loaderReducer,
  file: fileUploadReducer,
  document: documentReducer,
  auth: authReducer
});
